import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import { Header } from './components/Header';
import { Nav } from './components/Nav';
import { Home } from './components/Home';
import { Work } from './components/Work';
import { Project } from './components/Project';
import { Contact } from './components/Contact';
import Footer from './components/Footer';
import { FormSubmitted } from './components/FormSubmitted';

class App extends Component {
  render() {

    return (
      <Router onUpdate={() => window.scrollTo(0,0)}>
        <div className="App">
          <Header />
          <Nav />
          <div className="Page">
            <Switch>
              <Route exact path="/" component={ Home }/>
              <Route exact path="/work" component={ Work }/>
              <Route path="/contact" component={ Contact }/>
              <Route path="/work/:project_name" component={ Project }/>
              <Route path="/thanks" component={ FormSubmitted }/>
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js